import { createBrowserRouter, Outlet, ScrollRestoration } from "react-router-dom";
import { HomeScreen } from "../features/home/HomeScreen.tsx";
import { HostScreen } from "../features/host/HostScreen.tsx";
import { PublicFormScreen } from "../features/public-form/PublicFormScreen.tsx";
import { NotFoundScreen } from "../components/NotFoundScreen.tsx";
import { EventAnnouncementBar } from "../components/EventAnnouncementBar.tsx";

/**
 * Root layout. <ScrollRestoration> resets scroll to the top on each new navigation
 * (and restores the prior offset on back/forward, or scrolls to a #hash target),
 * so a page never inherits the previous route's scroll position.
 */
function RootLayout() {
  return (
    <>
      <ScrollRestoration />
      <EventAnnouncementBar />
      <Outlet />
    </>
  );
}

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: "/", element: <HomeScreen /> },
      // Static "/host" outranks the dynamic "/:slug" in React Router's route ranking.
      { path: "/host", element: <HostScreen /> },
      { path: "/:slug", element: <PublicFormScreen /> },
      { path: "*", element: <NotFoundScreen /> },
    ],
  },
]);
